"use strict";

exports.__esModule = true;
exports.getElementTop = getElementTop;
exports.getRootScrollTop = getRootScrollTop;
exports.getScrollEventTarget = getScrollEventTarget;
exports.getScrollHeight = getScrollHeight;
exports.getScrollTop = getScrollTop;
exports.getVisibleHeight = getVisibleHeight;
exports.pageScrollFix = pageScrollFix;
exports.scroll = scroll;
exports.scrolltoBtm = scrolltoBtm;
exports.setScrollTop = setScrollTop;
var _ = require(".");
var isServer = typeof window === 'undefined';

// get nearest scroll element
// http://w3help.org/zh-cn/causes/SD9013
// http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
function getScrollEventTarget(element, rootParent) {
  if (isServer) return;
  var node = element;
  while (node && node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType === 1 && node !== (rootParent || window)) {
    var _window$getComputedSt = window.getComputedStyle(node),
      overflowY = _window$getComputedSt.overflowY;
    if (overflowY === 'scroll' || overflowY === 'auto') {
      return node;
    }
    node = node.parentNode;
  }
  return rootParent || window;
}
function getScrollTop(element) {
  return 'scrollTop' in element ? element.scrollTop : element.pageYOffset;
}
function setScrollTop(element, value) {
  'scrollTop' in element ? element.scrollTop = value : element.scrollTo(element.scrollX, value);
}
function getScrollHeight(element) {
  return 'scrollHeight' in element ? element.scrollHeight : document.documentElement.scrollHeight;
}
function scrolltoBtm(element) {
  var el = 'scrollTop' in element ? element : document.documentElement;
  var scrollHeight = el.scrollHeight,
    clientHeight = el.clientHeight;
  setScrollTop(element, scrollHeight - clientHeight);
}
function getRootScrollTop() {
  if (isServer) return 0;
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}
function getElementTop(element) {
  if (isServer) return 0;
  return (element === window ? 0 : element.getBoundingClientRect().top) + getScrollTop(window);
}
function getVisibleHeight(element) {
  if (isServer) return 0;
  return element === window ? element.innerHeight : element.getBoundingClientRect().height;
}

// Hack for iOS12 page scroll
// https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800
function pageScrollFix() {
  if (_.isIOS) {
    window.scrollTo(window.pageXOffset, window.pageYOffset);
  }
}
function scroll(option, target, duration) {
  var _option;
  if (option === void 0) {
    option = 0;
  }
  if (duration === void 0) {
    duration = 30;
  }
  var stepCount = 0;
  var x;
  var y;
  typeof option === 'number' ? y = option : (_option = option, x = _option.x, y = _option.y, _option);
  var stepPI = Math.PI / duration;
  var initialPosition = {
    x: target ? target.scrollLeft : scrollX,
    y: target ? target.scrollTop : scrollY
  };
  target = target || window;
  if (!target.scrollTo) return;
  if (!window.requestAnimationFrame) return window.scrollTo(x, y);
  var step = function step() {
    if (stepCount < duration) {
      requestAnimationFrame(step);
      stepCount++;
      // eslint-disable-next-line no-restricted-properties
      var coefficient = 0.25 * Math.pow(1 - Math.cos(stepPI * stepCount), 2);
      target.scrollTo(x ? initialPosition.x + (x - initialPosition.x) * coefficient : 0, y ? initialPosition.y + (y - initialPosition.y) * coefficient : 0);
    }
  };
  requestAnimationFrame(step);
}